import React, { useState } from 'react';

const PRICE_PER_TON = 5200; // Example price, update as needed

const PricingCalculator = () => {
  const [quantity, setQuantity] = useState('');
  const total = quantity && !isNaN(quantity) ? PRICE_PER_TON * Number(quantity) : 0;

  return (
    <section className="max-w-xl mx-auto py-12 px-4">
      <h2 className="text-2xl font-bold text-center text-primary mb-6">Cement Pricing Calculator</h2>
      <form className="bg-white rounded-xl shadow-soft p-6 flex flex-col gap-4">
        <label className="text-primary font-semibold">Quantity (tons)</label>
        <input
          type="number"
          min="1"
          step="1"
          value={quantity}
          onChange={e => setQuantity(e.target.value)}
          className="border border-gray-300 rounded-xl px-4 py-2 focus:outline-accent text-base"
          placeholder="Enter quantity in tons"
        />
        <div className="flex justify-between items-center mt-4">
          <span className="text-primary">Price per ton:</span>
          <span className="font-semibold text-accent">₹{PRICE_PER_TON.toLocaleString()}</span>
        </div>
        <div className="flex justify-between items-center text-lg mt-2">
          <span className="font-bold text-primary">Total:</span>
          <span className="font-bold text-accent">₹{total.toLocaleString()}</span>
        </div>
      </form>
      <p className="text-xs text-gray-500 mt-4 text-center">* Prices are indicative. Contact us for bulk discounts or other materials.</p>
    </section>
  );
};

export default PricingCalculator; 